import { render, staticRenderFns } from "./dealerOrder.vue?vue&type=template&id=da1376a4&scoped=true&"
import script from "./dealerOrder.vue?vue&type=script&lang=js&"
export * from "./dealerOrder.vue?vue&type=script&lang=js&"
import style0 from "./dealerOrder.vue?vue&type=style&index=0&id=da1376a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da1376a4",
  null
  
)

export default component.exports